import React from "react";
import { css } from "emotion";
import MobileHeaderRow from "../../components/header/MobileHeaderRow";
import TitleBlock from "../../components/TitleBlock";
import PreviewBanner from "../../components/PreviewBanner";
import { boxStyles } from "../../styles/theme";

const EditHeaderMobile = () => {
  return (
    <div className={header}>
      <MobileHeaderRow />
      <TitleBlock
        title="Edit Spotlight"
        subtitle="Make changes and go live in seconds."
      />
      <PreviewBanner
        headlineText="Here's David Butterfield on why Slack beats Microsoft Teams every time."
        buttonText="Contact Us"
      />
    </div>
  );
};

export default EditHeaderMobile;

const header = css`
  box-shadow: ${boxStyles.boxShadow};
`;
